<template>
  <v-sheet class="mt-4 mx-4 align-center justify-center d-flex flex-wrap flex-row bg-white">
    <div>
      <modal-confirm
        title="Подать внеплановый РИД"
        label="Подать внеплановый РИД"
        @accept="() => doCreateUnplanned(projectId)"
      >
        <p>В рамках текущего проекта для вас будет создана новая проектная задача.</p>
        <p>
          В этой задаче вы сможете оформить и загрузить информацию о результатах интеллектуальной
          деятельности, не предусмотренных первоначальным планом.
        </p>
        <strong>Вы уверены, что хотите инициировать подачу внепланового РИД?</strong>
      </modal-confirm>
      <v-checkbox
        v-if="items.length"
        v-model="compactMode"
        class="ml-6"
        label="Компактный режим"
        density="compact"
        style="height: 26px"
      />
    </div>
    <filter-toggle
      v-if="items.length"
      v-model="sourceFilter"
      class="ma-4"
      :items="sourceFilterItems"
      :title="SourceFilter.title"
      :description="SourceFilter.description"
    />
    <filter-toggle
      v-if="items.length"
      v-model="statusFilter"
      :items="statusFilterItems"
      :title="StatusFilter.title"
      :description="StatusFilter.description"
    />
  </v-sheet>

  <v-row v-if="items.length" class="ma-4">
    <v-col v-for="(item, idx) in filteredItems" :key="idx" sm="12" md="4">
      <rid-entity
        :rid="item"
        :compact="compactMode"
        :source-filter="SourceFilter"
        :status-filter="StatusFilter"
        @realize="(pointHumanId) => doRealize(projectId, pointHumanId)"
        @actualize="
          (ridType, ridPlanCode, ridCode) => doActualize(projectId, ridType, ridPlanCode, ridCode)
        "
      />
    </v-col>
  </v-row>

  <v-card v-if="items.length === 0" class="ma-8 mx-auto" variant="plain" max-width="600">
    <v-card-item>
      <v-card-title class="py-6 text-center">Нет данных о РИД проекта</v-card-title>
      <v-card-text class="py-6 text-center">
        Сведения о результатах интеллектуальной деятельности отсутствуют
      </v-card-text>
    </v-card-item>
  </v-card>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import RidEntity from '@/components/Rid/RidEntity.vue'
import FilterToggle from '@/components/Rid/FilterToggle.vue'
import ModalConfirm from '@/components/Rid/ModalConfirm.vue'
import { useRidFilters } from '@/components/Rid/useRidFilters'
import { SourceFilter, StatusFilter } from '@/components/Rid/FilterConfig'
import { useRidActions } from '@/components/Rid/useRidActions'

const route = useRoute()

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
})

const compactMode = ref(true)

const sourceFilter = ref(SourceFilter.ALL)
const statusFilter = ref(StatusFilter.ALL)

const { sourceFilterItems, statusFilterItems, filteredItems } = useRidFilters(
  ref(props.items),
  sourceFilter,
  statusFilter,
)

const { doCreateUnplanned, doRealize, doActualize } = useRidActions()

const projectId = computed(() => {
  const match = route.path.match(/\/projects\/(\d+)/)
  return match ? parseInt(match[1], 10) : null
})
</script>

<style scoped lang="scss">

</style>
